import { render, staticRenderFns } from "./ImplantStep2.vue?vue&type=template&id=98d00dda&scoped=true&"
import script from "./ImplantStep2.vue?vue&type=script&lang=js&"
export * from "./ImplantStep2.vue?vue&type=script&lang=js&"
import style0 from "./ImplantStep2.vue?vue&type=style&index=0&id=98d00dda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d00dda",
  null
  
)

export default component.exports